import * as React from 'react';
import { useState } from 'react';
import Select from 'react-select';
import { Col, Container, Label, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { Afr, createAccount, DimensionReference, getRow, getRowIdForAccountAndDimensions, getSelectedAfr, getTable, NewAccount } from '../../../redux/AfrSlice';
import { Concept, getPublicName } from '../../../redux/ConceptSlice';
import { ColumnFilterAccountWithoutFact, selectColumnFilterAccountsWithoutFacts } from '../../../redux/MiscSlice';
import utilityHelper from '../../../utils/utilityHelper';
import Modal from './Modal';
import './ModalPopUp.css';

interface selectOption {
    value: string;
    label: string;
}
interface ddSelection {
    dimref: DimensionReference | null;
    selectedOptions: Array<selectOption>;
}

interface ddState {
    currentSelections: Array<ddSelection>;
}

function SelectSubAccountModal(props: any) {

    const dispatch = useAppDispatch();

    const [state, setState] = useState<ddState>(
        {
            currentSelections: [{ dimref: null, selectedOptions: [] }]
        }
    );


    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const acctTable = currentAfr ? getTable(currentAfr, props.tableName) : null;
    const accountName = props.row.account;
    const accountCode = props.row.accountCode;

    const columnFilterAccountsWithoutFacts = useAppSelector(selectColumnFilterAccountsWithoutFacts);

    // Handle Event
    const handleChange = (e: any, action: any) => {
        var member;
        var axisRank = Number(action.name.toString().replace('axe_', ''))
        const axes = state.currentSelections.map((key, index) => {

            if (acctTable) {
                var axis = acctTable.structure.rowHierarchy.axes[axisRank - 1];
                member = axis.membersByYear.find(subacc => subacc.code === e.value);
                if (member && ((index + 1) == axisRank)) {
                    var dr: DimensionReference = {
                        axis: axis,
                        member: member,
                        typedContent:""
                    };
                    var axeState = {
                        dimref: dr,
                        selectedOptions: [{ value: e.value, label: e.label }],
                    };
                    return axeState;
                }
            }
            return key;
        });
        
        setState({ currentSelections: axes });

    }

    // browse the and save temporarily in redux store
    const handleAddSubAccount = (e: any) => {

        //Validate that each dropdown is selected
        var dimrefs : Array<DimensionReference> = [];
        for (var itm of state.currentSelections) {

            if (itm.dimref) {
                if (itm.selectedOptions.length == 0) {
                    alert(itm.dimref.axis.name + " is mandatory")
                    return false;
                }
                dimrefs.push(itm.dimref);
            }
        }
        var rid = "";
        if (acctTable) {
            var account = acctTable.structure.rows.find(acc => acc.code === props.row.accountCode);
            if (!account) {
                alert("Account missing, please check!");
                return false;
            }
            // saving in AFR slice
            var afrAccount: NewAccount = {
                tableId: props.tableName,
                account: account,
                dimensions: dimrefs
            }

            rid = getRowIdForAccountAndDimensions(account, dimrefs);
            const row = getRow(acctTable, rid);

            if (row) {

                let dimensionalReferenceMemberIds: Set<string> = new Set<string>(dimrefs.map((dimRef: DimensionReference) => dimRef.member ? dimRef.member.id : null).filter((id): id is string => !!id));

                let shouldNotAddRow: boolean = false;

                if (row && row.account && row.account.code) {

                    let nonNullAccountCode: string = row.account.code;

                    if (props.columnFilter) {

                        shouldNotAddRow = utilityHelper.accountHasFactsWithFundGroup(nonNullAccountCode, currentAfr, props.columnFilter, props.tableName, dimensionalReferenceMemberIds);

                        if (shouldNotAddRow == true) {
                            alert("Account already exist, please check!");
                            return false;
                        } else {

                            if (dimensionalReferenceMemberIds.size > 0) {

                                let dimensionReferenceMemberCodes: Set<string> = new Set<string>(dimrefs.map((dimRef: DimensionReference) => dimRef.member ? dimRef.member.code : null).filter((code): code is string => !!code));

                                //the account code here has pipe delimited member ids for the sub accounts.  We need to add that before we perform the account code check.
                                nonNullAccountCode = nonNullAccountCode + "|" + Array.from(dimensionReferenceMemberCodes).join("|");
                            }

                            let hasBlankAccountEntry: boolean = columnFilterAccountsWithoutFacts.some((accountWithoutFacts: ColumnFilterAccountWithoutFact) =>
                                accountWithoutFacts.accountCode == nonNullAccountCode &&
                                accountWithoutFacts.columnFilter == props.columnFilter
                            );

                            if (hasBlankAccountEntry === true) {
                                alert("Account already exist, please check!");
                                return false;
                            }
                        }
                    } else {

                        shouldNotAddRow = utilityHelper.accountHasFactsWithFundGroup(nonNullAccountCode, currentAfr, null, props.tableName, dimensionalReferenceMemberIds);

                        if (shouldNotAddRow == true) {
                            alert("Account already exist, please check!");
                            return false;
                        }
                    }

                }
            }

            // Save the information in redux afr
            dispatch(createAccount(afrAccount));
        }
        //close modal
        props.onCloseModal(rid);

    }

    function renderDropdown(axeLabel: any, axeCode: any, options: any) {

        return (
            <React.Fragment key={axeCode}>

              <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>{axeLabel}:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select key={axeCode}
                                name={'axe_' + axeCode}
                                onChange={handleChange}
                                autoFocus={(axeCode === 1)}
                                options={options}
                                isOptionDisabled={(option: any) => option.isdisabled}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                    <br />
                    <br />
              </Container>
            </React.Fragment >
        );
    }

    const getScopedInfo = function (accCode: string): string {
        var scInfo = "";
        if (props.scopeMappings) {
            if (props.scopeMappings.accountMappings.hasOwnProperty(accCode) && props.scopeMappings.filter.indexOf(accCode) >= 0) {
                // We are a fund group restricted account, check and see if we're in the exclusion filter for this fund group
                scInfo += " (use only for ";
                scInfo += props.scopeMappings.accountMappings[accCode].map((c: Concept) => getPublicName(c)).join(", ");
                scInfo += ")";
            }
        }
        return scInfo;
    }
    const isDisabled = function (accCode: string): boolean {
        if (!acctTable) {
            return false;
        }
        if (props.scopeMappings && props.scopeMappings.accountMappings.hasOwnProperty(accCode)) {
            // We are a fund group restricted account, check and see if we're in the exclusion filter for this fund group
            if (props.scopeMappings.filter.indexOf(accCode) >= 0) {
                return true;
            }
        } else {
            if (acctTable.structure.rowHierarchy.axes) {
                return false;
            }
        }
        if (acctTable.rows.findIndex(row => row.account !== null && row.account.code === accCode) === -1) {
            return false;
        }
        return true;
    }
    function generateDropdowns(initializeState: boolean) {

        // Render the controls
        var axes : any[] = [];
        var render : any[] = [];
        var axe_i: number = 1;
       
        if (!acctTable || !acctTable.structure || !acctTable.structure.rowHierarchy) {
            render.push(<span></span>);
            return render;
        }

        var dimensionCount = acctTable.structure.rowHierarchy.axes.length;
        var account = acctTable.rows.filter(acc => (acc.account !== null && acc.account.code === props.row.accountCode));

        for (var axe of acctTable.structure.rowHierarchy.axes) {
            const options = axe.membersByYear.map(opc => ({
                value: opc.code,
                label: opc.name,
                isdisabled: dimensionCount === 1 ? (account.findIndex(subrow =>
                                                                        subrow.dimensions[0].member !== null && subrow.dimensions[0].member.code === opc.code) === -1
                                                                        ? false : true) : false
            }));

            // Just choose the first member in the axis for a default
            var defaultRef: DimensionReference = {
                axis: axe,
                member: axe.membersByYear[0],
                typedContent: ""
            }
            var axeState : ddSelection = {
                dimref: defaultRef,
                selectedOptions: [],
            };

            axes.push(axeState);

            // create controls
            render.push(renderDropdown(axe.name, axe_i, options));
            axe_i = axe_i + 1;
        }

        if (initializeState) {
            setState({ currentSelections: axes });
        }

        return (render);

    }


    const renderControls = generateDropdowns(false);

    React.useEffect(() => {

        generateDropdowns(true);

    }, [props]);

        
    return (
        <React.Fragment >
        <Modal isOpen={props.isOpen} onClose={props.onCloseModal}>
            <div className="ModalPopUp">
                <h4>Adding sub-account</h4>
                <br/>
                Account #:<b> {accountName} </b>

                    <br/>
                    {renderControls}
                   
               
                <div>
                    <button onClick={handleAddSubAccount} className="btn btn-primary mr-4">
                        Add
                    </button>
                    <button onClick={props.onCloseModal} className="btn btn-primary">
                        Cancel
                    </button>
                </div>
            </div>
            </Modal>
        </React.Fragment >
    );
}

export default SelectSubAccountModal;